import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Project Management Mentorship Program",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Project Management Mentorship Program</h2>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/pmmp.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>In today's competitive landscape, project management excellence is not just about managing projects; it is about managing your career. This bespoke mentorship Program will equip you with the strategic knowledge, practical skills, and industry insights needed to excel in project management and unlock unparalleled career opportunities.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Mentoring Service</h5>
                                                    <p>Over the years, I have seen many aspiring project managers struggle with career progression, lack of practical experience, and difficulty obtaining certifications. This mentorship program is designed to bridge the gap between theory and real-world application, providing you with structured guidance, industry insights, and hands-on coaching. Whether you are preparing for PMP, Scrum, or Change Management certifications, or seeking to advance in your career, this Program will equip you with the skills, confidence, and knowledge to thrive.</p>

                                                    <h5 className="title mt-3">Mentorship Plan</h5>

                                                    <h6>Phase 1: Foundation MasteryHow is the mentorship structured?</h6>
                                                    <ul className="liststyle">
                                                        <li>Core PM Concepts & Methodologies (Agile, Waterfall, Hybrid).</li>
                                                        <li>Practical application through exercises: WBS, Gantt charts, risk matrices.</li>
                                                        <li>Weekly reviews of PMBOK topics.</li>
                                                    </ul>
                                                    
                                                    <h6 className="mt-3">Phase 2: Real-World Application</h6>
                                                    <ul className="liststyle">
                                                        <li>Case study analysis of project successes/failures.</li>
                                                        <li>Capstone Project simulation: creating charters, schedules, and budgets.</li>
                                                        <li>Personal project application for practical skill reinforcement.</li>
                                                    </ul>
                                                    
                                                    <h6 className="mt-3">Phase 3: Career Advancement</h6>
                                                    <ul className="liststyle">
                                                        <li>PM job titles & responsibilities clarity.</li>
                                                        <li>Resume & portfolio building workshop.</li>
                                                        <li>Interview readiness: mock interviews, STAR method, common questions.</li>
                                                    </ul>

                                                    <h6 className="mt-3">Phase 4: Certification and Specialisation</h6>
                                                    <ul className="liststyle">
                                                        <li>Agile & Scrum certification preparation (CSM/PSM).</li>
                                                        <li>Advanced certification planning (PMP, Prince2, ITIL).</li>
                                                        <li>Industry-specific knowledge deep dives.</li>
                                                    </ul>

                                                    <h6 className="mt-3">Phase 5: Professional Growth and Networking</h6>
                                                    <ul className="liststyle">
                                                        <li>Change management strategies (ADKAR)</li>
                                                        <li>Networking & job search techniques.</li>
                                                        <li>Ongoing mentorship, reflection & goal setting.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this mentorship, you will:</h5>
                                                    <ul className="liststyle">
                                                        <li>Master core and advanced project management methodologies</li>
                                                        <li>Apply PM principles to real-world scenarios and capstone projects.</li>
                                                        <li>Build a compelling PM resume and portfolio.</li>
                                                        <li>Excel in PM job interviews with confidence.</li>
                                                        <li>Prepare for and achieve industry-recognised certifications.</li>
                                                        <li>Navigate change management and stakeholder resistance.</li>
                                                        <li>Expand your professional network and find PM career opportunities.</li>
                                                        <li>Develop industry-specific knowledge and expertise.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this mentorship, you will leave with:</p>
                                                    
                                                    <ul className="liststyle">
                                                        <li>A comprehensive understanding of project management principles and practices</li>
                                                        <li>Real-world project experience.</li>
                                                        <li>A powerful PM resume and portfolio.</li>
                                                        <li>Confidence in PM job interviews.</li>
                                                        <li>Certification readiness and strategic career plan.</li>
                                                        <li>A robust professional network.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">Who is this mentorship program for?</h5>
                                                    <ul className="liststyle">
                                                        <li>Aspiring Project Managers: Individuals seeking to enter the field of project management.</li>
                                                        <li>Junior Project Managers: Professionals looking to advance their skills and career trajectory.</li>
                                                        <li>Project Coordinators: Individuals aiming to transition into project management roles.</li>
                                                        <li>Team Leads: Professionals wanting to enhance their project management capabilities within their team.</li>
                                                        <li>Professionals seeking PMP, Prince2, or Agile certifications: Individuals aiming to achieve industry-recognised certifications.</li>
                                                        <li>Professionals looking to improve their job search readiness: Individuals needing guidance on resume building, portfolio creation, and interview skills.</li>
                                                        <li>Individuals seeking career advancement in project management: Professionals looking to climb the ladder and take on more senior roles.</li>
                                                        <li>Professionals transitioning into project management roles from other fields: Professionals who have transferable skills that can be applied to project management.</li>
                                                        <li>Individuals in need of career direction in project management.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the mentorship structured?</h5>
                                                    <p>This comprehensive 6-month Program features bi-weekly one-on-one sessions, practical workshops, case study analysis, and ongoing support. You will also gain access to exclusive resources, a dedicated online community, and personalised feedback.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this mentorship suitable for professionals with varying levels of Project Management experience?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the Program is tailored to your specific needs and experience level, from junior to senior professionals.</p>

                                                        <li>Will this mentorship help me prepare for specific Project Management certifications?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. I provide dedicated modules for Scrum, PMP, Prince2, and ITIL certification preparation.</p>

                                                        <li>Are there networking opportunities included in this mentorship?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, I guide you in building your professional network and connecting with industry professionals.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £799</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("Project Management Mentorship Program", "https://mainstack.store/coachdoi/9ljwWYLkITwi")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;